import React from "react";

import { type Annotation } from "@features/custom-annotations";
import { getDateOnly } from "@utils/datetime";

import { useAnnotationParam } from "../hooks/use-annotation-param";

import { AnnotationCard } from "./annotation-card";
import { getSort, type SortValue } from "./annotation-sort-select";

interface AnnotationsProps {
  annotations: Annotation[];
  currentSort: SortValue | null;
  editAnnotation: (annotation: Annotation) => void;
}

export const Annotations = ({
  annotations,
  currentSort,
  editAnnotation,
}: AnnotationsProps) => {
  const { filteredAnnotationDateRangeParam } = useAnnotationParam();

  const filteredAnnotations = annotations.filter((annotation) => {
    if (filteredAnnotationDateRangeParam) {
      const start = getDateOnly(filteredAnnotationDateRangeParam.startDate);
      const end = getDateOnly(filteredAnnotationDateRangeParam.endDate);
      const date = getDateOnly(annotation.annotatedDate);
      return start <= date && date <= end;
    }
    return true;
  });

  const sortedAnnotations = getSort(currentSort)(filteredAnnotations);

  return (
    <div
      className="mt-6 flex flex-col gap-5 overflow-y-auto h-[calc(100vh-260px)]"
      data-test="annotation-list"
    >
      {sortedAnnotations.length === 0 ? (
        <div className="self-center mt-4">No notes found</div>
      ) : (
        sortedAnnotations.map((annotation, index) => (
          <AnnotationCard
            key={index}
            editAnnotation={editAnnotation}
            annotation={annotation}
          />
        ))
      )}
    </div>
  );
};
